import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import Brightness1Icon from '@mui/icons-material/Brightness1';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import { actionTypes, useStateValue } from '../../store';
import Header from '../BaseComponents/Header';
import FotterMain from '../BaseComponents/FotterMain';
import { getCustomerOrderList } from '../../networkCalls';
import LoadingCellFullPage from '../LoadingCell/LoadingCellFullPage';

const MyOrders = () => {


    const [{ token, huid }, dispatch] = useStateValue();
    const [loading, setLoading] = useState(false);
    const [orderlistData, setOrderlistData] = useState([]);

    const checkOrderListData = () => {
        var data = new FormData();
        data.append('customerId', huid);
        data.append('XAuth', token);
        setLoading(true);
        getCustomerOrderList(data).then((res) => {
            setLoading(false);
            switch (res.data.status) {
                case 1:
                    setOrderlistData(res?.data?.orderData)

                    return true;
                case 0:

                    break;
                case 2:
                    dispatch({ type: actionTypes.SET_TOKENMODAL, value: true });
                    break;
                default:
                    return;
            }
        })
    }
    useEffect(() => {
        checkOrderListData();
    }, [token, huid, dispatch]);
    return (
        <>
            <Header />
            {loading ? <><LoadingCellFullPage /></> : <>
                <div className='innerpagebg pt-5 pb-5'>
                    <div className='container'>
                        <div className='row'>
                            <div className='col-9 text-left m-auto'>
                                <div className="d-flex align-items-center">
                                    <h4 className='d-inline-block m-0 fw-bold text-uppercase'>
                                        <span className='txtred'>My </span> <span className='txtdgray'>Orders ({orderlistData?.length})</span>
                                    </h4>
                                    {/* <div className="ms-auto">
                                    <Link to="/myaccount/update-address" className='d-block mt-3 fw-bold'>
                                        ADD NEW ADDRESS
                                    </Link>
                                </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='container mt-3'>
                        <div className='row'>
                            <div className='col-lg-9 col-md-12 col-12 m-auto'>
                                {orderlistData && orderlistData?.length > 0 && orderlistData?.map((data, key) => (
                                    <div className='card p-3 mb-3' key={key} >
                                        <Link to={`/myaccount/order-details/${data?.orderId}`}>
                                            <div className="row text-black">
                                                <div className="col-lg-6 col-12">
                                                    <div className="row">
                                                        <div className="col-lg-12 col-12">
                                                            <div className="">
                                                                <div className='f12 mt-1'>
                                                                    <span className="text-black fw-bold">Order ID : </span>
                                                                    <span className="">{data?.orderId}</span>
                                                                </div>
                                                                <div className='f12 mt-1'>
                                                                    <span className="text-black fw-bold">Order Date : </span>
                                                                    <span className="">{data?.orderDate}</span>
                                                                </div>
                                                                <div className='f12'>
                                                                    <span className="text-black fw-bold">Dealer : </span>
                                                                    <span className="">{data?.dealerName}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-lg-2 col-12 fw-bold">
                                                    <CurrencyRupeeIcon className='f14 fw-bold' />{data?.paymentAmount}
                                                </div>
                                                <div className="col-lg-4 col-12">
                                                    <div>
                                                        <span className="f12 fw-bold"><Brightness1Icon className='text-success f12 me-1' />{data?.status}</span>
                                                        <div className='f12'>
                                                            <span className="text-muted">Transaction Id : </span>
                                                            <span className="">{data?.transactionId}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </>}
            <FotterMain />
        </>
    )
}

export default MyOrders